import type { ValueOf } from './util/typeUtils';

export const SLACE_CONTACT_STATUSES = {
    CREATED: 'CREATED',
    FAILED: 'FAILED',
    PENDING: 'PENDING',
} as const;
export type SLACE_CONTACT_STATUS = ValueOf<typeof SLACE_CONTACT_STATUSES>;

export const SLACE_FAILURE_REASONS = {
    CONTACT_ALREADY_EXISTS: 'CONTACT_ALREADY_EXISTS',
    FORBIDDEN: 'FORBIDDEN',
    UNAUTHORIZED: 'UNAUTHORIZED',
    UNEXPECTED_ERROR: 'UNEXPECTED_ERROR',
    UNPROCESSABLE_ENTITY: 'UNPROCESSABLE_ENTITY',
} as const;
export type SLACE_FAILURE_REASON = ValueOf<typeof SLACE_FAILURE_REASONS>;

export const SLACE_GENDERS = {
    DIVERSE: 'diverse',
    FEMALE: 'female',
    MALE: 'male',
} as const;
export type SLACE_GENDER = ValueOf<typeof SLACE_GENDERS>;
